<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <AuthForm :title="$t('general.connect')"
              :button-label="$t('general.login')"
              @submit="login">
        <template v-slot:formFields>
            <v-col cols="12">
                <v-text-field
                        class="custom_textfield"
                        v-model="user.email"
                        :error-messages="emailErrors"
                        :label="$t('general.email')"
                        :clearable=true
                        name="email"
                        prepend-inner-icon="person"
                        type="text"
                        @input="$v.user.email.$touch()"
                        @blur="$v.user.email.$touch()"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field
                        class="custom_textfield"
                        v-model="user.password"
                        id="password"
                        :error-messages="passwordErrors"
                        :label="$t('general.password')"
                        :clearable=true
                        name="password"
                        prepend-inner-icon="lock"
                        type="password"
                        @input="$v.user.password.$touch()"
                        @blur="$v.user.password.$touch()"
                        outlined
                ></v-text-field>
            </v-col>
        </template>
        <template v-slot:forgotPasswordLink>
            <v-col class="forgot_password_link" cols="12">
                <a href="/forgot-password">{{ $t('general.forgotPassword') }}</a>
            </v-col>
        </template>
    </AuthForm>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, minLength, email, alphaNum} from 'vuelidate/lib/validators'
    import AuthForm from '../components/AuthForm.vue'

    export default {
        components: {
            AuthForm
        },
        mixins: [validationMixin],
        validations: {
            user: {
                email: {
                    required,
                    email
                },
                password: {
                    required,
                    minLength: minLength(6)
                }
            }
        },
        data: () => ({
            drawer: null,
            user: {
                email: '',
                password: ''
            }
        }),
        computed: {
            emailErrors() {
                const errors = [];
                if (!this.$v.user.email.$dirty) return errors;
                !this.$v.user.email.required && errors.push(this.$t('validation.required'));
                !this.$v.user.email.email && errors.push(this.$t('validation.email'));
                return errors;
            },
            passwordErrors() {
                const errors = [];
                if (!this.$v.user.password.$dirty) return errors;
                !this.$v.user.password.required && errors.push(this.$t('validation.required'));
                !this.$v.user.password.minLength && errors.push(this.$t('validation.minLength', {num: this.$v.user.password.$params.minLength.min}));
                return errors;
            }
        },
        methods: {
            login() {
                // Check if form input is valid.
                this.$v.user.$touch();
                if (!this.$v.user.$invalid) {
                    // send request to server
                    axios.post(`${this.$store.state.api_url}/api/login`, this.user)
                        .then(async (response) => {
                            // Save accessToken and user data from response to browser indexedDB.
                            await this.$store.state.indexedDbAppStore.setItem('accessToken', response.data.token);
                            await this.$store.state.indexedDbUserStore.setItem('user', response.data.user);

                            // Save accessToken and user data from response to Vuex instance.
                            this.$store.commit('mutateAccessToken', response.data.token);
                            this.$store.commit('mutateUser', response.data.user);

                            await this.$store.dispatch('setAuthHeader', {accessToken: response.data.token});

                            // After successful login redirect to home page.
                            this.$router.push('/');
                        })
                        .catch(error => {
                            this.$store.dispatch('showResponseNotification', {
                                "response": error.response, "timeout": 5000
                            });
                        })
                }
            }
        },
    }
</script>